import { render } from "./Ledger.vue?vue&type=template&id=2d90298e&scoped=true"
import script from "./Ledger.vue?vue&type=script&lang=js"
export * from "./Ledger.vue?vue&type=script&lang=js"

import "./Ledger.vue?vue&type=style&index=0&id=2d90298e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d90298e"]])

export default __exports__